import {OrderService, ErrorHandler} from 'hasta-la-vista-middleware-api/service'
import Vue from 'vue'

let zeroPad = (num, places) => {
    let zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
};

export default {
    props: {
        timer: null,
        // movieSession: null
    },

    data() {
        return {
            now: (new Date()).getMinutes(),
            date: null,
            diff: 0,
            expires: null,
            currentTime: 0,
            session: undefined,
            CountDownTimer: undefined,
            loading: true,
            minutes: undefined,
            seconds: undefined,
            cancelOrderLoad: false,
            toggleDialog: false,
            warningTime: "06:00",
            showWarning: false,
            showTimeout: false,
            loadingContinue: false,
            order: null,
        }
    },

    methods: {

        confirmCancelOrder() {
            this.toggleDialog = true
        },

        cancelOrder(){
            ErrorHandler.ignoreNextError();
            this.cancelOrderLoad = true;
            let session = OrderService.pendingSession();
            let result = Promise.resolve(OrderService.cancelOrder()).then((result) => {
                this.showWarning = false
                OrderService.clearPendingSessions();
                OrderService.tearDown();
                this.$toaster.show('Your booking was successfully cancelled.', {
                    top: true,
                    fullwidth: true,
                    timeout: 5000
                });
                this.cancelOrderLoad = false
                Vue.nextTick(()=>{
                    this.$router.push('/details/' + session.MovieId);
                })
            }, (e) => {
                this.showWarning = false
                let session = OrderService.pendingSession();
                OrderService.tearDown();
                Vue.nextTick(()=>{
                    this.$router.push('/details/' + session.MovieId);
                })
            });
        },

        goHome(){
            this.showTimeout = false
            this.cancelOrderLoad = true
            OrderService.tearDown();
            Vue.nextTick(()=>{
                this.$router.push('/');
            })
        },

        continueOrder(){
            this.loadingContinue = true;
            OrderService.continueOrder().then((continued)=> {
                this.showWarning = false
                this.loadingContinue = false
            })
        },

        restartOrder(){
            this.loadingContinue = true;
            OrderService.restartOrder().then((order)=> {
                this.loadingContinue = false;
                this.showTimeout = false;
                this.showWarning = false;
                order.loadSeatGrid();
                this.order = order;
                this.setExpiry(order.ExpiryDate.date);
                window.location.href = (`/booking/1 ${this.$route.params.festival_id ? '/film-festival/' + this.$route.params.festival_id : ''}`);
                this.startTimer();
            });
        },


        calcExpiry() {
            if (this.expires) {
                let now = new Date();
                let secs = this.expires.diff(now, 'seconds');
                let min = Math.floor(secs / 60);
                min = min < 0 ? 0 : min;
                secs = secs - (min * 60);
                secs = secs < 0 ? 0 : secs;

                this.minutes = zeroPad(min, 2);
                this.seconds = zeroPad(secs, 2);
            } else {
                this.minutes = zeroPad(0, 2);
                this.seconds = zeroPad(0, 2);
            }
            if (!this.cancelOrderLoad) {
                if (`${this.minutes}:${this.seconds}` === this.warningTime) this.showWarning = true;
                if (`${this.minutes}:${this.seconds}` === "00:00") {
                    this.showWarning = false;
                    this.showTimeout = true;
                }
            }
        },

        setExpiry(updatedDate){
            let exp = this.expires = updatedDate;
            return exp;
        },

        startTimer() {
            this.CountDownTimer = setInterval(this.calcExpiry, 1000);
        },
        stopTimer() {
            if (this.CountDownTimer) clearInterval(this.CountDownTimer);
        }

    },

    beforeDestroy() {
        this.stopTimer();
    },

    created() {
        this.loading = true;
        try {
            if (!OrderService.pendingSession()) {
                this.$toaster.show('Oops, it looks like we cannot find a booking for you. here\'s what\'s on', {
                    top: true,
                    fullwidth: true,
                    timeout: 5000
                });
                this.$router.push('/');
            } else
                OrderService.getOrder().then((order)=> {
                        this.order = order;
                        if (order.Session && !order.VistaBookingNumber) {
                            this.setExpiry(order.ExpiryDate.date);
                            OrderService.addObserver(this, OrderService.ORDER_CHANGED_EVENT, (evt, order)=> {
                                this.setExpiry(order.ExpiryDate.date)
                            });
                            this.startTimer();
                        }
                        if (!order.Sessions || order.Sessions.length == 0) {
                            if (OrderService.pendingSession()) {
                                this.showTimeout = true;
                            } else {
                                this.$toaster.show('Oops, it looks like we cannot find a booking for you. here\'s what\'s on', {
                                    top: true,
                                    fullwidth: true,
                                    timeout: 5000
                                });
                                this.$router.push('/');
                            }
                        }
                        this.loading = false

                    },
                    (error)=> Promise.reject(error)
                );
        } catch (e) {
            this.$toaster.show('An Unexpected error has occured, please try again later.', {
                top: true,
                fullwidth: true,
                timeout: 5000
            });
            this.$router.push('/');
        }

    }
}


// WEBPACK FOOTER //
// ./src/components/booking/countdown/countdown.js